import axios from 'axios'

const instance = axios.create({
  // 使用相对路径，通过 nginx 反向代理访问后端 API
  // 开发环境可通过 .env.development 配置 VUE_APP_API_BASE_URL
  // 生产环境统一通过 /api/ 路径访问
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api/',
  timeout: 5000
})

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = localStorage.getItem('token')
    return config
  },
  (error) => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 在这里的response是正常请求后可以获取的全部response,因此在这一层第一步应该过滤浏览器层面的请求失败的情况,对应的就是下面异常捕获时要处理的
    // 如果进入到这里面说明client响应server成功 此时response不可能是 null 或 undefine 此时我们关注的是response的data属性 最次server返回个null 对应 response.data= ''
    // console.log(response)
    /* <==============================>STR<==============================> */
    // 从这里开始需要写后端自定义的异常，你需要怎么处理 //
    /* <====================>^^^<====================> */
    const data = response.data
    if (data === '') {
      console.log('server return null')
    } else if (data.code !== undefined && data.code !== null) {
      if (data.code === 200) {
        // 返回 msg='调用成功'和data.data构成的组合对象
        return {
          msg: '调用成功',
          data: data.data
        }
      } else {
        switch (data.code) {
          case 0:
            console.log(
              '异常CODE:',
              data.code,
              'msg:',
              data.msg || 'data.msg未定义或者为null、undefined 业务异常提示未定义',
              'xxx异常'
            )
            break
          case 2:
            console.log(
              '异常CODE:',
              data.code,
              'msg:',
              data.msg || 'data.msg未定义或者为null、undefined 业务异常提示未定义',
              'xxx异常'
            )
            break
          case 3:
            console.log(
              '异常CODE:',
              data.code,
              'msg:',
              data.msg || 'data.msg未定义或者为null、undefined 业务异常提示未定义',
              'xxx异常'
            )
            break
          default:
            console.log('未定义的业务异常')
        }
        return Promise.reject(
          new Error(data.msg || 'data.msg未定义或者为null、undefined 业务异常提示未定义')
        )
      }
    } else {
      return Promise.reject(
        new Error(data.msg || 'data.msg未定义或者为null、undefined 业务异常提示未定义')
      )
    }
    /* <====================>===<====================> */
    // COMMENT COMMENT COMMENT COMMENT COMMENT COMMENT//
    /* <==============================>END<==============================> */
  },
  (error) => {
    console.log('发生异常:', error)
    return Promise.reject(error)
  }
)

export default instance
